<template>
  <div class="message-button">
    <a class="message-button__link" :href="`https://wa.me/${phone}`" target="_blank">
      <FileIconComponent name="whatsapp" />
    </a>
    <div v-if="schedule" class="message-button__text">
      <span> {{ schedule }} </span>
    </div>
  </div>
</template>

<script>
import FileIconComponent from "components/FileIconComponent.vue";
export default {
  name: "MessageButtonComponent",
  components: { FileIconComponent },
  computed: {
    schedule() {
      return this.$store.state.marketplace?.schedule || undefined;
    },
    phone() {
      if (
        this.$store.state.marketplace?.communications &&
        this.$store.state.marketplace.communications.length
      ) {
        return this.$store.state.marketplace.communications
          .find((item) => item.type.code === this.$store.state._types.PHONE)
          ?.value.replace(/\D+/g, "");
      }
      return "79896680101";
    },
  },
};
</script>

<style lang="stylus">
.message-button {
  position fixed
  bottom 72px
  right 24px
  z-index 10
  display flex
  align-items center
  +below(768px) {
    bottom 132px
  }
  +below(410px) {
    bottom 72px
  }

  &__link {
    display flex
    justify-content center
    align-items center
    width: 50px
    height: 50px
    background rgb(77, 194, 71)
    border-radius 50%

    &:hover {
      box-shadow: rgba(0, 0, 0, 0.7) 2px 2px 11px;
    }

    .file-icon {
      width 40px
      height 40px

      svg path {
        fill var(--white)
      }
    }
  }

  &:hover &__text {
    visibility visible
    opacity 1
    transform translate(0, -50%)
  }

  &__text {
    position absolute
    top 50%
    right 100%
    visibility hidden
    opacity 0
    transform translate(10px, -50%)
    padding-right 20px
    transition var(--transition)

    span {
      position relative
      display flex
      box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 13px;
      border: 1px solid rgb(226, 226, 226);
      border-radius: 5px;
      background: var(--white);
      text-align: center;
      padding: 7px 10px;
      width 150px

      &:after {
        content: "";
        position: absolute;
        background: var(--white);
        border-bottom: 1px solid rgb(226, 226, 226);
        border-right: 1px solid rgb(226, 226, 226);
        right: -5px;
        top: 50%;
        margin-top: -4px;
        width: 8px;
        height: 8px;
        z-index: 1;
        transform: rotate(-45deg);
      }
    }
  }
}
</style>
